import { Component } from '@theme/component';

/** Clearly disclosed image samples; CSS owns the intrinsic masonry layout. */
class NpProductReviewSamples extends Component {
  #abort;
  #trigger;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  #bind() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const options = { signal: this.#abort.signal };
    const dialog = this.querySelector('dialog');
    const large = this.querySelector('[data-demo-large]');
    const caption = this.querySelector('[data-demo-caption]');
    const close = dialog?.querySelector('button');
    if (!(dialog instanceof HTMLDialogElement) || !(large instanceof HTMLImageElement) || !caption || !close) return;

    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const photo = event.target.closest('[data-demo-photo]');
      if (!(photo instanceof HTMLButtonElement) || !this.contains(photo)) return;
      const image = photo.querySelector('img');
      if (!(image instanceof HTMLImageElement)) return;
      this.#trigger = photo;
      const label = photo.getAttribute('aria-label') || '';
      large.src = image.currentSrc || image.src;
      large.alt = label;
      large.width = image.naturalWidth || image.width;
      large.height = image.naturalHeight || image.height;
      caption.textContent = label;
      if (!dialog.open) dialog.showModal();
      close.focus();
    }, options);
    close.addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => {
      if (this.#trigger?.isConnected) this.#trigger.focus();
    }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, options);
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#trigger = undefined;
    super.disconnectedCallback();
  }
}

if (!customElements.get('np-product-review-samples')) {
  customElements.define('np-product-review-samples', NpProductReviewSamples);
}
